import { DocumentModels } from './document.models';
import { PolicyModels } from './policy.models';
import { PropertyChange } from './property-change';
import { RequestModels } from './request.models';

export namespace AvenantModels {
  export enum AvenantTypeEnum {
    InformationsAssure = 1,
    ChangementVehicule = 2,
  }

  export enum AvenantTypeEnumGestion {
    ChangementGarantie = 3,
    ChangementDateEffet = 4,
    Immatriculation = 5,
    UsageVehicule = 6,
    Antecedants,
  }

  export interface ChoseAvenantsTypeForm {
    avenantTypes: AvenantTypeAll[];
    avenantTypesGestion: AvenantTypeAll[];
    effectDate: string;
  }

  export type AvenantTypeAll = AvenantTypeEnum | AvenantTypeEnumGestion;

  export interface AvenantRecap {
    changes: PropertyChange<PolicyModels.PolicyChangeEnum>[];
    priceDiff: AvenantPriceDiff;
    hasValidation: boolean;
  }

  export interface AvenantInformations {
    id?: number;
    publicId?: string;
    recap: AvenantRecap;
    request?: PolicyModels.AvenantRecapRequest;
    effectDate?: Date;
    avenantRequestDocumentId?: number;
    state?: RequestModels.RequestStateEnum;
    creationDate?: Date;
    attestationFileUrl?: string;
    devisFileUrl?: string;
    uploadedFragments?: DocumentModels.FragmentData[];
    initialChanges?: PropertyChange<PolicyModels.PolicyChangeEnum>[];
    initialPriceDiff?: AvenantPriceDiff;
    complements?: AvenantComplementInformations[];
    rejectReason?: string;
    lastStateId?: number;
    acceptedDate?: Date;
    minDateNextAvenant?: Date;
    isEligibleResilAssureur?: boolean;
  }

  export interface AvenantComplementInformations {
    amount: number;
    id: number;
    state: PolicyModels.ComplementStateEnum;
    comments: string;
  }

  export interface AvenantPriceDiff {
    oldPrice?: number;
    newPrice?: number;
    newPriceRenewed?: number;
    oldPriceRenewed?: number;
    diff?: number;
    receiptsDetails?: AvenantReceiptDetails[];
  }

  export interface AvenantReceiptDetails {
    type: PolicyModels.ReceiptTypeEnum;
    receiptOrder: number;
    receiptNumber: string;
    startDate: Date;
    endDate: Date;
    oldPrice: number;
    newPrice: number;
    moneyGap: number;
    toPayWithNewRiskPercentage: number;
    hasAttemptTax: boolean;
    infoTooltip: string;
  }

  export interface AvenantRequest {
    publicId: string;
    creationDate: Date;
    state: RequestModels.RequestStateEnum;
    effectDate: Date;
    acceptedDate?: Date;
    id: number;
    attestationFileUrl: string;
    rejectReason?: string;
    lastStateId?: number;
    resilEcheance?: boolean;
  }

  export interface SaveAvenantResponse {
    devisUrl: string;
    requestId: number;
  }
}
